__turbopack_context__.v({
  "site-preferences-form": "_6sVSna_site-preferences-form",
  "site-preferences-form__content": "_6sVSna_site-preferences-form__content",
  "site-preferences-form__content--reduce-spacing": "_6sVSna_site-preferences-form__content--reduce-spacing",
  "site-preferences-form__fieldset": "_6sVSna_site-preferences-form__fieldset",
  "site-preferences-form__footer": "_6sVSna_site-preferences-form__footer",
  "site-preferences-form__heading": "_6sVSna_site-preferences-form__heading",
  "site-preferences-form__legend": "_6sVSna_site-preferences-form__legend",
  "site-preferences-form__separator": "_6sVSna_site-preferences-form__separator",
  "site-preferences-form__sub-heading": "_6sVSna_site-preferences-form__sub-heading",
});
